import BaseAPI from './base'

class ExerciseStoreAPI extends BaseAPI {}

export default new ExerciseStoreAPI('v1/exercise-stores', 'ExerciseStore')
